import { useLoaderData, useRouteError, useRouteLoaderData } from "react-router-dom";
import { IIdentifiable, withContainer } from "../../core";
import { EnsureComponent } from "../../../components-common/_shared/conditionals/EnsureComponent";
import { RootieView } from "../../../_runtime/screens/RootieView";
import { SupportedComponent } from "../../../components-common/_types";
import React from "react";
import { useScreen } from "./screen-provider";
import { Loader } from "taltech-styleguide";

export const RootieScreen = <TProps extends IIdentifiable>(props?: {id:string}) => {
  const screenProps = useScreen();
  if(screenProps !== null) return <RootieView {...screenProps as any} />;
  return <Loader fullScreen />;
}

const SupportedComponentSwitch = ({ component }:SupportedComponent) => {
  if (React.isValidElement(component)) {
    return component;
  }

  if (typeof component === 'function') {
    return React.createElement(component);
  }

  if ('Component' in component) {
    const { Component, props } = component;
    return <Component {...props} />;
  }

  if ('cat' in component) {
    const { Component, props } = component;
    return <Component {...props} />;
  }

  return null;
};

export const RenderChildren: React.FC<any> = (props:any) => {
  const { children = [] } = props;
  return (
    <>
      {(children as any).map((child:any, index: number) => (
        <SupportedComponentSwitch key={child.key || child.id || index.toString()} component={child} />
      ))}
    </>
  );
};

const RootieComponentInner: React.FC<any> = ({ component }) => {
  const { children=[] } = component;
  return (
    <>
      {SupportedComponentSwitch({component})}
      {children && children.length > 0 && <RenderChildren children={children} />}
    </>
  );
};

export const RootieComponent: React.FC<any> = withContainer(RootieComponentInner);
